<div class="navigation">
  <div class="flex flex-row pl-5 pr-5">
    <mat-form-field class="subject flex-auto">
      <mat-label></mat-label>
      <mat-select [(ngModel)]="selectedProperty" (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let property of properties" [value]="property">
          {{ property?.name || property.address?.address_string }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <treo-vertical-navigation
    [navigation]="menuData"
    [inner]="true"
    [mode]="'side'"
    [opened]="true"
  ></treo-vertical-navigation>
</div>
